/** Leesbare browser uit een user-agent ("Chrome 155 · macOS"); de volledige tekst blijft als tooltip beschikbaar. */
export function browserName(ua: string): string {
  const pick = (re: RegExp) => ua.match(re)?.[1];
  const major = (v?: string) => v?.split(".")[0];
  const browser = pick(/Edg\/([\d.]+)/)
    ? `Edge ${major(pick(/Edg\/([\d.]+)/))}`
    : pick(/Firefox\/([\d.]+)/)
      ? `Firefox ${major(pick(/Firefox\/([\d.]+)/))}`
      : pick(/Chrome\/([\d.]+)/)
        ? `Chrome ${major(pick(/Chrome\/([\d.]+)/))}`
        : pick(/Version\/([\d.]+).*Safari/)
          ? `Safari ${major(pick(/Version\/([\d.]+).*Safari/))}`
          : null;
  const os = /iPhone|iPad/.test(ua)
    ? "iOS"
    : /Android/.test(ua)
      ? "Android"
      : /Mac OS X/.test(ua)
        ? "macOS"
        : /Windows/.test(ua)
          ? "Windows"
          : /Linux/.test(ua)
            ? "Linux"
            : null;
  const parts = [browser, os].filter(Boolean);
  return parts.length ? parts.join(" · ") : ua;
}
